import { createSlice } from "@reduxjs/toolkit";
import { adminHeatmapReportAction } from "../../actions/AdminActions/AdminHeatmapAction";

const initialState: any = {
    report: null,
    adminreportLoading: false
}

const AdminHeatmapSlice = createSlice({
    name: "admin",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(adminHeatmapReportAction.pending, (state) => {
                state.adminreportLoading = true
            })
            .addCase(adminHeatmapReportAction.fulfilled, (state, action) => {
                state.adminreportLoading = false
            })
            .addCase(adminHeatmapReportAction.rejected, (state) => {
                state.adminreportLoading = false
            })
    }
})

export default AdminHeatmapSlice.reducer;